import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { HighlightOverlay } from './styles';

interface RequiredActionHighlightProps {
  selector: string;
  isActive: boolean;
}

const RequiredActionHighlight: React.FC<RequiredActionHighlightProps> = ({
  selector,
  isActive,
}) => {
  const [position, setPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  });

  const updatePosition = useCallback(() => {
    const element = document.querySelector(selector);
    if (element) {
      const rect = element.getBoundingClientRect();
      setPosition({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        height: rect.height,
      });
    }
  }, [selector]);

  useEffect(() => {
    if (!isActive || !selector) return;

    // Initial position
    updatePosition();

    // Update on scroll and resize
    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);

    // Update periodically in case of DOM changes (reduzido para 1s para melhor performance)
    const interval = setInterval(updatePosition, 1000);

    // eslint-disable-next-line consistent-return
    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
      clearInterval(interval);
    };
  }, [selector, isActive, updatePosition]);

  if (!isActive || !selector) return null;

  return createPortal(
    <HighlightOverlay
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        width: `${position.width}px`,
        height: `${position.height}px`,
      }}
    />,
    document.body,
  );
};

export default RequiredActionHighlight;
